import { get, post, put } from 'utils/apiClient';
import React, { createContext, useState } from 'react';

const ApptSysContext = createContext();

function Provider({ children }) {
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [apptSystems, setApptSystems] = useState([])
    const [createResponse, setCreateResponse] = useState()
    const [errorMessage, setErrorMessage] = useState('')

    const loadApptSystems = async () => {
        setLoading(true)
        try {
            const data = await get('crs/appmt_sys?feature=apptsys');
            if (data) setApptSystems(data);
            setLoading(false)
        } catch (error) {
            console.error('Load systems error:', error);
            setLoading(false)
            setError(true)
        }
    };

    const submitCreate = async (payload) => {
        setLoading(true)
        try {
            const savedData = await post('crs/appmt_sys?feature=apptsys', payload);
            await loadApptSystems(); 

            const response = {
                message: 'System created successfully',
                data: savedData
            };
            setCreateResponse(response)
            setLoading(false)
            setSuccess(true)
        } catch (error) {
            console.error('Create error:', error);
            setErrorMessage(error.message)
            setLoading(false)
            setError(true)
        }
    }

    const submitUpdate = async (payload) => {
        setLoading(true)
        try {
            // PUT is a full replace — payload must be the complete system object.
            const savedData = await put('crs/appmt_sys?feature=apptsys', payload);
            await loadApptSystems();

            const response = {
                message: 'System updated successfully',
                data: savedData
            };
            setCreateResponse(response)
            setLoading(false)
            setSuccess(true)
        } catch (error) {
            console.error('Update error:', error);
            setErrorMessage(error.message)
            setLoading(false)
            setError(true)
        }
    }

    const valueToShare = {
        loading, setLoading,
        success, setSuccess,
        error, setError,
        apptSystems, setApptSystems,
        loadApptSystems,
        submitCreate,
        submitUpdate,
        createResponse,
        errorMessage
    }

    return (
        <ApptSysContext.Provider value={valueToShare}>
            {children}
        </ApptSysContext.Provider>
    )
}

export { Provider }
export default ApptSysContext